module.exports = "<div class=\"chart\">\n  <div [chart]=\"chartService.icuCharts.urea.rr.chart\"></div>\n</div>"